var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCiudad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4333",
    "data-name": "Group 4333",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.652,
    height: 25.465,
    viewBox: "0 0 21.652 25.465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #002e6b;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7512",
    "data-name": "Path 7512",
    className: "cls-1",
    d: "M3.356,24.269V4.054l4.24-.009.032-2.853L14.04,1.2l.036,2.845,4.255.015v20.2l-5.31.014L13,20.166l-4.364.011-.014,4.1ZM6.5,0l-.03,2.855-4.274.036,0,21.363L0,24.29l.021,1.175,9.73-.008.008-4.118,2.112-.007.02,4.132,9.751,0,.011-1.18-2.164-.025V6.02l0-3.135L15.2,2.85,15.194,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7513",
    "data-name": "Path 7513",
    className: "cls-1",
    d: "M168.028,134.878l-2.128,0-.007-2.415,2.127-.011Z",
    transform: "translate(-151.726 -121.142)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7514",
    "data-name": "Path 7514",
    className: "cls-1",
    d: "M116.249,134.817l-2.158.02-.011-2.415,2.156-.02Z",
    transform: "translate(-104.338 -121.095)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7515",
    "data-name": "Path 7515",
    className: "cls-1",
    d: "M116.242,77.808l-2.159.026-.009-2.416,2.157-.026Z",
    transform: "translate(-104.332 -68.953)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7516",
    "data-name": "Path 7516",
    className: "cls-1",
    d: "M65.131,77.672,63,77.695l-.012-2.417,2.126-.036Z",
    transform: "translate(-57.608 -68.816)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7517",
    "data-name": "Path 7517",
    className: "cls-1",
    d: "M116.263,191.388l-2.163.03-.007-2.413,2.155-.009Z",
    transform: "translate(-104.35 -172.857)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7518",
    "data-name": "Path 7518",
    className: "cls-1",
    d: "M65.157,191.429l-2.135.006v-2.408l2.13-.006Z",
    transform: "translate(-57.64 -172.88)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7519",
    "data-name": "Path 7519",
    className: "cls-1",
    d: "M168,191.435l-2.122.026,0-2.423,2.13,0Z",
    transform: "translate(-151.713 -172.895)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7520",
    "data-name": "Path 7520",
    className: "cls-1",
    d: "M65.121,134.826l-2.131.017-.012-2.419,2.133-.013Z",
    transform: "translate(-57.6 -121.103)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7521",
    "data-name": "Path 7521",
    className: "cls-1",
    d: "M167.983,77.86l-2.129.018.009-2.428h2.124Z",
    transform: "translate(-151.691 -69.006)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCiudad);
export default __webpack_public_path__ + "static/media/Icon_Ciudad.80753591d9484703a05f264c0f66897d.svg";
export { ForwardRef as ReactComponent };